import ListFilters from '@/common/components/ListFilters'
import useDebounce from '@/common/hooks/useDebounce'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { CompanyBranchData } from '@/common/types/companyBranches.type'
import { Option } from '@/common/types/option'
import { useCompanies } from '@/features/companies/hooks/useCompanies'
import { CompaniesTransformer } from '@/features/companies/services/companiesTransformer'
import { useAvailableCompanyBranches } from '@/features/privateCompanies/hooks/companyBranches/useAvailableCompanyBranches'

const Filters = () => {
  const { filterParams, setFilterParams } = useFilterParams()

  const [searchCompany, setSearchCompany] = useDebounce('')
  const [searchCompanyBranch, setSearchCompanyBranch] = useDebounce('')

  const { data: companyOptions } = useCompanies({
    filters: { search: searchCompany },
    mapper: Mapper.mapWithTransformer({ transformer: CompaniesTransformer.optionsTransformer() }),
  })

  const { data: companyBranchesOptions } = useAvailableCompanyBranches({
    companyId: filterParams.client?.value,
    filters: {
      search: searchCompanyBranch,
    },
    mapper: Mapper.mapToOptions<CompanyBranchData>({
      labelFieldName: 'display_name',
      valueFieldName: 'id',
    }),
  })

  return (
    <div className="flex gap-x-2 z-50">
      <ListFilters
        filters={[
          {
            className: 'min-w-56',
            onChange: (client) => setFilterParams((prev) => ({ ...prev, client })),
            value: filterParams.client,
            onInputChange: (value) => setSearchCompany(value),
            options: [{ label: 'Todas', value: '' }, ...((companyOptions || []) as Option[])],
            placeholder: 'Empresa',
          },

          {
            className: 'min-w-56',
            onChange: (e) => setFilterParams((prev) => ({ ...prev, branch: e })),
            value: filterParams.branch,
            onInputChange: setSearchCompanyBranch,
            disabled: !filterParams.client?.value,
            options: [{ label: 'Todas', value: '' }, ...(companyBranchesOptions || [])],
            placeholder: `Filial${!filterParams.client?.value ? ' (Selecione uma empresa)' : ''}`,
          },
        ]}
      />
    </div>
  )
}

export default Filters
